var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.575 6.50407C15.8411 6.16462 15.9901 5.74885 16 5.31845C16.0098 4.88805 15.88 4.46596 15.6297 4.11482L13.2749 0.834246C13.0899 0.576286 12.8456 0.366014 12.5625 0.220913C12.2794 0.0758119 11.9655 7.50866e-05 11.6471 0L4.35265 0C4.03417 7.50866e-05 3.72032 0.0758119 3.43718 0.220913C3.15405 0.366014 2.90981 0.576286 2.72478 0.834246L0.370001 4.11482C0.120213 4.46625 -0.00916076 4.88843 0.00104935 5.31878C0.0112595 5.74913 0.16051 6.16475 0.426686 6.50407L7.99985 16L15.575 6.50407ZM4.83414 5.97312L6.70142 12.233L1.70577 5.97312H4.83414ZM14.2939 5.97312L9.30161 12.233L11.1656 5.97312H14.2939ZM9.77443 5.97312L7.99985 11.9323L6.22526 5.97312H9.77443ZM6.21659 4.64576L7.16891 1.32736H8.83079L9.7831 4.64576H6.21659ZM12.1899 1.60544L14.3719 4.64576H11.1709L10.2179 1.32736H11.6471C11.7532 1.32735 11.8579 1.35258 11.9523 1.40095C12.0467 1.44932 12.1282 1.51943 12.1899 1.60544ZM3.8098 1.60544C3.8715 1.51943 3.95295 1.44932 4.04737 1.40095C4.14179 1.35258 4.24645 1.32735 4.35265 1.32736H5.78178L4.82947 4.64576H1.62842L3.8098 1.60544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.d2388607101cf649bb815878708444d5.svg";
export { ForwardRef as ReactComponent };